'use client';

import { useEffect } from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('[game] route error boundary', error);
  }, [error]);

  return (
    <main className="game-shell">
      <div className="game-fallback">
        <h2>页面加载失败</h2>
        <p>{error.message || '应用初始化失败。'}</p>
        <button type="button" onClick={() => reset()}>
          重试
        </button>
      </div>
    </main>
  );
}
